import styled from 'styled-components';

export const ContainerList = styled.li`
  font-size: 12px !important;
  font-weight: 500 !important;

  img {
    width: 14px;
  }

  .badge-ia {
    background-color: #11b37d;
    color: #fff;
    font-size: 12px;
    padding: 5px 5px 5px 6px;
  }
`;
